export enum MobileWebAppPopupMode {
  SHOW_POPUP_CLOSABLE = 'SHOW_POPUP_CLOSABLE',
  SHOW_POPUP_NOT_CLOSABLE = 'SHOW_POPUP_NOT_CLOSABLE',
  NOT_SHOW_POPUP = 'NOT_SHOW_POPUP',
}
